import React from "react"
import { useEffect, useState } from "react"
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai"
// import logo from "../assets/github.png"
import logo from "../assets/Akruti_logo.jpg"
import logo2 from "../assets/Akruti_logo-removebg-preview.png"
import { navLinks } from "../constants"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      if (scrollTop > 100) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const [toggle, setToggle] = useState(false)

  useEffect(() => {
    if (toggle) {
      document.body.classList.add("menu-open")
    } else {
      document.body.classList.remove("menu-open")
    }
  }, [toggle])

  return (
    <>
      <header
        className={` fixed z-30 top-0 w-full flex items-center justify-between py-5 md:py-8 lg:py-8 xl:py-8 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] mx-auto ${
          toggle ? "bg-transparent" : scrolled ? "header-bg" : "bg-transparent"
        } `}
        
      >
        <div></div>
        <h1 className={`flex-row text-center relative  header-logo pl-6 ${
    toggle ? "hidden" : ""
  }`}>
          <a className="block hover:opacity-70 -z-20 " href="#">
            <img
              className="w-full  h-auto max-h-[93.28px] "
              src={logo2}
              alt="company logo"
            ></img>
          </a>
        </h1>
        <div className="relative">
          {!toggle ? (
            <div className="flex  relative items-center ">
              <AiOutlineMenu
                size={40}
                className="w-auto h-auto cursor-pointer"
                onClick={() => setToggle(!toggle)}
              />
            </div>
          ) : (
            <div className="relative top-0 right-0 z-20">
              <AiOutlineClose
                size={40}
                className="cursor-pointer"
                onClick={() => setToggle(!toggle)}
              />
            </div>
          )}{" "}
        </div>{" "}
      </header>
      {toggle && (
        <div className="menu-wrapper  is-active">
          <div className="  w-screen h-screen relative  menu-container  ">
            <nav className=" absolute z-40 top-1/2 right-0 transform translate-y-[-40%] pr-[12px] md:pr-[100px] lg:pr-[140px] w-full">
              <ul className="  flex flex-col items-end menu-list menu-items-list md:pt-36 lg:pt-44 md:pb-24  ">
                {navLinks.map((nav) => (
                  <motion.li
                    key={nav.id}
                    initial={{ translateY: 80, opacity: 0 }}
                    animate={{
                      translateY: toggle ? 0 : 80,
                      opacity: toggle ? 1 : 0,
                    }}
                    transition={{ delay: 0.1, duration: 0.5 }}
                    className="block py-2 xl:py-3 2xl:py-4 "
                  >
                    <a
                      className="uppercase text-xl sm:text-3xl lg:text-4xl 2xl:text-5xl font-semibold text-white"
                      href={`#${nav.id}`}
                      onClick={() => setToggle(!toggle)}
                    >
                      {nav.title}
                    </a>
                  </motion.li>
                ))}
              </ul>
              <motion.ul
                initial={{ opacity: 0 }}
                animate={{ opacity: toggle ? 1 : 0 }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="social-menu-small  mt-14 md:mt-0 md:translate-y-[-70%] md:relative translate-y-[-80%] xl:translate-y-[-90%] absolute flex flex-col items-start md:items-start sm:items is-active text-black pl-0 pb-20  lg:pl-20 md:pl-10    max-w-lg social-class
                "
              >
                <li className="pt-5">
                  <a
                    className="flex items-center "
                    href="https://www.linkedin.com/company/akruti-concept-studio/"
                    target="_blank"
                    rel="noopener"
                  >
                    <span className="mr-3 w-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                      >
                        <path d="M34.1 16.947c3.688 0 7.224 1.47 9.83 4.087a13.97 13.97 0 014.065 9.479l.005.382V46a1 1 0 01-.883.993L47 47h-8.6a1 1 0 01-.993-.883L37.4 46V30.895c0-.88-.348-1.724-.968-2.346a3.292 3.292 0 00-4.664 0 3.323 3.323 0 00-.96 2.127l-.007.219V46a1 1 0 01-.884.993l-.116.007h-8.6a1 1 0 01-.993-.883L20.2 46V30.895c0-3.699 1.464-7.246 4.07-9.861a13.875 13.875 0 019.83-4.087zm-21.5 2.158a1 1 0 01.993.883l.007.117V46a1 1 0 01-.884.993L12.6 47H4a1 1 0 01-.993-.884L3 46V20.105a1 1 0 01.883-.993L4 19.105h8.6zm21.5-.158a11.875 11.875 0 00-8.412 3.498 11.97 11.97 0 00-3.482 8.098l-.005.352L22.2 45h6.6V30.895c0-1.233.428-2.422 1.2-3.368l.17-.199.182-.19a5.292 5.292 0 017.497 0 5.323 5.323 0 011.545 3.493l.006.264V45h6.599L46 30.895c0-2.93-1.072-5.749-2.997-7.928l-.246-.27-.244-.252a11.875 11.875 0 00-8.413-3.498zM11.6 21.104H5v23.895h6.599V21.104zM8.299 4c2.929 0 5.3 2.38 5.3 5.316 0 2.935-2.371 5.316-5.3 5.316C5.373 14.632 3 12.25 3 9.316S5.372 4 8.3 4zm0 2A3.308 3.308 0 005 9.316a3.308 3.308 0 003.3 3.316c1.821 0 3.3-1.484 3.3-3.316A3.308 3.308 0 008.3 6z"></path>
                      </svg>
                    </span>
                    <span className="font-semibold text-sm sm:text-lg md:text-lg">
                      Akruti Concept Studio
                    </span>
                  </a>
                </li>

                <li className="pt-5">
                  <a
                    className="flex items-center"
                    href="https://www.facebook.com/Rahul.V.Deshmukh/"
                    target="_blank"
                    rel="noopener"
                  >
                    <span className="mr-3 w-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                      >
                        <path d="M36.91 3.1H30.66a11.27 11.27 0 00-8.002 3.342l-.24.25a11.447 11.447 0 00-3.071 7.808l-.001 5.4H14a.9.9 0 00-.9.9v8.4l.007.113A.9.9 0 0014 30.1l5.347-.001V46a.9.9 0 00.9.9h8.332l.112-.007A.9.9 0 0029.48 46l-.001-15.901 5.348.001a.9.9 0 00.874-.683l2.083-8.4.02-.106a.9.9 0 00-.894-1.011h-7.431v-5.4c0-.32.126-.626.35-.851.221-.224.521-.349.833-.349h6.248a.9.9 0 00.9-.9V4a.9.9 0 00-.9-.9zm-.901 1.8v6.6h-5.348c-.792 0-1.552.317-2.112.881a3.009 3.009 0 00-.87 2.119v6.3l.007.113a.9.9 0 00.893.787h7.179l-1.637 6.6h-5.542l-.113.007a.9.9 0 00-.787.893l-.001 15.9h-6.531V29.2l-.006-.113a.9.9 0 00-.893-.787H14.9v-6.6h5.348a.9.9 0 00.9-.9v-6.3a9.644 9.644 0 012.789-6.79A9.47 9.47 0 0130.66 4.9h5.348z"></path>
                      </svg>
                    </span>
                    <span className="font-semibold text-sm sm:text-lg md:text-lg">
                      Akruti Concept Studio
                    </span>
                  </a>
                </li>

                <li className="pt-5">
                  <a
                    className="flex items-center"
                    href="https://www.instagram.com/arnavvvvv/?hl=en"
                    target="_blank"
                    rel="noopener"
                  >
                    <span className="mr-3 w-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                      >
                        <path d="M35.25 3c6.092 0 11.088 4.778 11.401 10.828l.012.293.004.296V35.25c0 6.092-4.778 11.088-10.828 11.401l-.294.012-.295.004H14.417c-6.092 0-11.088-4.778-11.402-10.828l-.011-.294L3 35.25V14.417C3 8.325 7.778 3.329 13.828 3.015l.293-.011.296-.004H35.25zM14.43 5l-.269.003c-5.002.133-9.018 4.163-9.157 9.146L5 14.417v20.82l.003.268c.133 5.003 4.163 9.019 9.146 9.158l.268.004h20.82l.268-.004c5.003-.133 9.019-4.162 9.158-9.145l.004-.268V14.43l-.004-.269c-.133-5.002-4.162-9.018-9.145-9.157L35.25 5H14.43zm11.864 10.51a9.333 9.333 0 11-2.738 18.464 9.333 9.333 0 012.738-18.464zm-4.746 2.723a7.333 7.333 0 106.755 13.018 7.333 7.333 0 00-6.755-13.018z"></path>
                        <path d="M36.314 12.375a1 1 0 01.116 1.993l-.137.007a1 1 0 01-.117-1.993l.138-.007z"></path>
                      </svg>
                    </span>
                    <span className="font-semibold text-sm sm:text-lg md:text-lg ">
                      @Akruti Concept Studio
                    </span>
                  </a>
                </li>

                {/* <li className="pt-5">
                  <a
                    className="flex items-center"
                    href="https://x.com/home"
                    target="_blank"
                    rel="noopener"
                  >
                    <span className="mr-3 w-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                      >
                        <path d="M30.566 5.676A10.325 10.325 0 0025.7 9.508l-.204.31a10.253 10.253 0 00-1.58 5.608l-.001 1.061h-.023a21.296 21.296 0 01-9.089-2.248 21.178 21.178 0 01-7.82-6.722 1 1 0 00-1.73.17l-.108.255-.095.24-.11.293a25.335 25.335 0 00-.662 2.076c-1.192 4.362-1.4 8.948.015 13.275l.12.358c1.532 4.38 4.66 8.03 9.602 10.714l.488.258-.166.097A23.346 23.346 0 012.04 38.19c-1.054-.041-1.446 1.365-.524 1.875 20.214 11.175 43.15-.974 43.15-24.716l-.008-.385c-.01-.257-.03-.512-.06-.766l-.031-.229.233-.246a16.98 16.98 0 004.005-7.465c.22-.897-.79-1.587-1.546-1.057l-.444.304c-1.49.992-3.1 1.796-4.788 2.395l-.438.148-.053-.056a10.345 10.345 0 00-4.78-2.686 10.377 10.377 0 00-5.84.243l-.35.126zm5.707 1.572a8.34 8.34 0 014.266 2.603 1 1 0 001.04.3l.56-.176a23.768 23.768 0 003.772-1.604l.077-.043-.153.336a15.004 15.004 0 01-3.035 4.251 1 1 0 00-.282.903c.097.506.147 1.02.149 1.535l-.007.662c-.389 20.189-18.572 31.057-36.176 24.182l-.437-.176.062-.007a25.323 25.323 0 0011.034-4.14 1 1 0 00-.155-1.744C11.146 31.546 7.7 27.81 6.195 23.205c-1.276-3.9-1.085-8.11.014-12.127l.117-.417.12-.4.037-.116.08.097a23.191 23.191 0 007.345 5.785 23.299 23.299 0 0011.035 2.458 1 1 0 00.974-1v-2.073a8.266 8.266 0 011.436-4.777 8.325 8.325 0 013.923-3.09 8.377 8.377 0 014.997-.297z"></path>
                      </svg>
                    </span>
                    <span className="font-semibold text-sm sm:text-lg md:text-lg">
                      @Akruti Concept Studio
                    </span>
                  </a>
                </li> */}
              </motion.ul>
            </nav>
          </div>
        </div>
      )}
    </>
  )
}

export default Header
